import { StandardObject } from '../../../../../common/interfaces/api/CustomerReport';

export enum EnergizedContact {
	OverheadWire = StandardObject.PowerLine,
	UndergroundWire = 'Exposed underground wire',
}
